(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.hero-carousel').forEach(function (el) {
    var slides = el.querySelectorAll('[data-slide-index]');
    var dots = el.querySelectorAll('[data-dot-index]');
    if (slides.length < 2) return;

    var current = 0;
    var timer = null;
    var autoplay = el.dataset.autoplay === 'true';
    var interval = parseInt(el.dataset.interval, 10) || 5000;

    function goTo(index) {
      slides[current].classList.remove('is-active');
      dots[current].classList.remove('is-active');
      current = index;
      slides[current].classList.add('is-active');
      dots[current].classList.add('is-active');
    }

    function next() {
      goTo((current + 1) % slides.length);
    }

    function startAutoplay() {
      if (autoplay && !timer) {
        timer = setInterval(next, interval);
      }
    }

    function stopAutoplay() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        stopAutoplay();
        goTo(parseInt(this.dataset.dotIndex, 10));
        startAutoplay();
      });
    });

    startAutoplay();
  });

  } catch(e) { console.error(e); }
})();
})();
